<template>
  <v-sheet height="100%" class="item">
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <v-container v-if="!loading" class="py-10 py-md-13 py-lg-16">
        <v-row justify="center" align="center">
          <v-col cols="12" md="6">
            <img
              v-if="item.img"
              class="d-block item-img"
              :src="files + item.img"
              width="100%"
            />

            <TitleWidget v-else>CONTATO</TitleWidget>
          </v-col>
          <v-col cols="12" md="6">
            <h2 class="text-h4 font-weight-bold white--text">
              Entre em contato
            </h2>
            <p class="white--text">
              Estamos sempre à disposição para atender às suas necessidades.
              Entre em contato conosco para saber mais sobre nossos serviços e
              produtos.
            </p>
            <v-btn
              color="success"
              :href="informations.whatsapp_float"
              target="_blank"
            >
              <v-icon class="mr-2">fa-whatsapp</v-icon>
              <span>WhatsApp</span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="mt-2 mt-md-6">
          <v-col cols="12">
            <v-row>
              <v-col
                cols="12"
                md="6"
                v-for="(
                  {
                    title,
                    title_short,
                    tel,
                    whatsapp,
                    xerox,
                    address,
                    google_maps,
                  },
                  keyContacts
                ) in contacts"
                :key="keyContacts"
              >
                <v-card
                  class="contact-card fill-height"
                  elevation="3"
                  rounded="lg"
                >
                  <v-card-title
                    class="
                      contact-card__head
                      subtitle-1
                      font-weight-bold
                      secondary--text
                      pb-2
                      d-flex
                      align-start
                      flex-nowrap
                    "
                  >
                    <v-icon
                      color="secondary"
                      size="22"
                      class="mr-2 flex-shrink-0"
                    >
                      fa-store
                    </v-icon>
                    <span class="contact-card__title-text">{{
                      title_short || title
                    }}</span>
                  </v-card-title>
                  <v-divider class="mx-4" />
                  <v-card-text class="pt-4 pb-4">
                    <a
                      v-if="address"
                      class="contact-card__row contact-card__link text-body-2"
                      :href="google_maps"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <v-icon
                        color="secondary"
                        size="20"
                        class="contact-card__icon mr-2"
                      >
                        fa-map-marker-alt
                      </v-icon>
                      <span>{{ address }}</span>
                    </a>
                    <a
                      v-if="tel"
                      class="contact-card__row contact-card__link text-body-2"
                      :href="getTelLinkFromPhone(tel)"
                    >
                      <v-icon
                        color="secondary"
                        size="18"
                        class="contact-card__icon mr-2"
                      >
                        fa-phone-alt
                      </v-icon>
                      <span class="font-weight-medium">{{ tel }}</span>
                    </a>
                    <a
                      v-if="whatsapp"
                      class="contact-card__row contact-card__link text-body-2"
                      :href="getWhatsappLinkFromPhone(whatsapp)"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <v-icon
                        color="secondary"
                        size="20"
                        class="contact-card__icon mr-2"
                      >
                        fa-whatsapp
                      </v-icon>
                      <span class="font-weight-medium">{{ whatsapp }}</span>
                    </a>
                    <a
                      v-if="xerox"
                      class="contact-card__row contact-card__link text-body-2"
                      :href="getWhatsappLinkFromPhone(xerox)"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <v-icon
                        color="secondary"
                        size="20"
                        class="contact-card__icon mr-2"
                      >
                        fa-whatsapp
                      </v-icon>
                      <span class="font-weight-medium">
                        {{ xerox }} — Xerox
                      </span>
                    </a>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </transition>
  </v-sheet>
</template>

<script>
import { getTelLinkFromPhone } from "../utils/getTelLinkFromPhone";
import { getWhatsappLinkFromPhone } from "../utils/getWhatsappLinkFromPhone";
import groupBy from "lodash.groupby";
import TitleWidget from "../components/widgets/TitleWidget.vue";
import LoadingWidget from "../components/widgets/LoadingWidget.vue";

const _config = {
  mod: "links",
};

export default {
  data: () => ({
    loading: true,
    contacts: [],
  }),
  created() {
    const item = this.$rest("linksConfig").get({
      save: (state, data) => (state.item = data),
    });

    const items = this.$rest(_config.mod).get();

    Promise.all([item, items]).then(() => (this.loading = false));

    this.$rest("stores").get({
      save: (state, data) => (this.contacts = data),
    });
  },
  computed: {
    item() {
      return this.$rest("linksConfig").item;
    },
    informations() {
      return this.$rest("informations").item;
    },
    items() {
      return this.$rest(_config.mod).list;
    },
    itemsSeparatedInTwiceColumns() {
      const itemsGroupBy = groupBy(this.items, "category.title");

      const list = [];

      Object.entries(itemsGroupBy).forEach((entry) => {
        const [index, item] = entry;

        list.push({
          title: index,
          list: item,
        });
      });

      const middleIndex = Math.ceil(list.length / 2);

      return [list.splice(0, middleIndex), list.splice(-middleIndex)];
    },
  },
  methods: {
    getTelLinkFromPhone,
    getWhatsappLinkFromPhone,
  },
  components: {
    TitleWidget,
    LoadingWidget,
  },
};
</script>

<style lang="scss" scoped>
.item {
  background: rgb(88, 193, 215);
  background: -moz-linear-gradient(
    180deg,
    rgba(88, 193, 215, 1) 8%,
    rgba(0, 142, 207, 1) 70%
  );
  background: -webkit-linear-gradient(
    180deg,
    rgba(88, 193, 215, 1) 8%,
    rgba(0, 142, 207, 1) 70%
  );
  background: linear-gradient(
    180deg,
    rgba(88, 193, 215, 1) 8%,
    rgba(0, 142, 207, 1) 70%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#58c1d7",endColorstr="#008ecf",GradientType=1);

  &-img {
    height: 100%;
    max-height: 400px;
    -o-object-fit: contain;
    object-fit: contain;
  }
}

.item::v-deep {
  .v-btn {
    border-width: 2px !important;
  }
}

.contact-card {
  background: #fff !important;
  border: 1px solid rgba(255, 255, 255, 0.65);
  box-shadow: 0 4px 18px rgba(0, 46, 82, 0.12) !important;
  transition: box-shadow 0.2s ease, transform 0.2s ease;

  &:hover {
    box-shadow: 0 10px 32px rgba(0, 46, 82, 0.2) !important;
    transform: translateY(-2px);
  }

  &__head {
    line-height: 1.35;
  }

  &__title-text {
    word-break: break-word;
  }

  &__row {
    display: flex;
    align-items: flex-start;
    text-decoration: none;
    min-width: 0;

    & + & {
      margin-top: 14px;
    }
  }

  &__icon {
    flex-shrink: 0;
    margin-top: 1px;
  }

  &__link {
    color: rgba(0, 0, 0, 0.72) !important;
    transition: color 0.15s ease;

    &:hover,
    &:focus {
      color: var(--v-secondary-base) !important;
    }
  }
}
</style>
